import { useEffect, useState } from "react";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import { setPutPayloadWithParams } from "../../../services/api";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Download, RestartAlt } from "@mui/icons-material";
import { formatNumberWithCommas } from "../../utils/UrlHandle";
import LoadingBackDrop from "../../global/LoadingBackDrop";
import PDFViewerDialog from "../../jasperReports/PDFViewerDialog";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const IncomeExpenseByMonth = () => {
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const [selectedYear, setSelectedYear] = useState(dayjs(new Date()));
  const [selectedMonth, setSelectedMonth] = useState(dayjs(new Date()));
  const [selectedMonthName, setSelectedMonthName] =
    useState("dayjs(new Date())");
  const [incomeData, setIncomeData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [totalIncome, setTotalIncome] = useState("0.00");
  const [totalExpense, setTotalExpense] = useState("0.00");
  const [openCashFlowDialog, setOpenCashFlowDialog] = useState(false);

  const handleCloseCashFlow = () => {
    setOpenCashFlowDialog(false);
  };
  const loadBasicData = async () => {
    try {
      console.log("year ", selectedYear);
      console.log("year ", selectedMonth);
      setLoading(true);
      const response = await setPutPayloadWithParams.setPayloadData(
        "/labReq/categorySum",
        null,
        {
          year: selectedYear,
          month: selectedMonth,
        }
      );

      console.log("dash", response.data);

      setIncomeData(response.data.incomeArray);
      setExpenseData(response.data.expenseArray);

      // const arrayIncome = response.data.listIncomeOnly;
      // const arrayExpense = response.data.listExpenseOnly;

      // const arrayProfit = arrayIncome.map(
      //   (value, index) => value - arrayExpense[index]
      // );

      // console.log("arrpro ", arrayProfit);
      const totalIncome = response.data.incomeArray.reduce(
        (sum, item) => sum + item.totalAmount,
        0
      );

      const totalExpense = response.data.expenseArray.reduce(
        (sum, item) => sum + item.amount,
        0
      );

      console.log("totalIncome ", totalIncome);

      setTotalIncome(totalIncome);
      setTotalExpense(totalExpense);

      // const totalExpense = arrayExpense.reduce((accumulator, currentValue) => {
      //   return accumulator + currentValue;
      // }, 0);

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);

    if (newDate) {
      // Extract year and month
      const year = newDate.year();
      const month = newDate.month() + 1; // Month is 0-indexed, so add 1
      const monthName = newDate.format("MMMM"); // Full month name

      setSelectedYear(year);
      setSelectedMonth(month);
      setSelectedMonthName(monthName);
      console.log(`Selected Year: ${year}`);
      console.log(`Selected Month: ${month} (${monthName})`);

      // Use in your application logic
      // For example: submitToAPI(year, month);
    } else {
      setSelectedYear(null);
      setSelectedMonth(null);
    }
  };

  return (
    <Box>
      {loading && <LoadingBackDrop openBackDrop={loading} />}
      <Box display="flex" gap={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ width: 200 }}>
            <DatePicker
              label="Select year & month"
              openTo="year"
              views={["year", "month"]}
              yearsOrder="desc"
              // value={selectedDate}
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                  fullWidth: true,
                },
              }}
            />
          </Box>
        </LocalizationProvider>
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={() => loadBasicData()}
          startIcon={<RestartAlt />}
          loading={loading}
        >
          Load Data
        </Button>
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={() => setOpenCashFlowDialog(true)}
          startIcon={<Download />}
          loading={loading}
        >
          DOWNLOAD
        </Button>
      </Box>
      <Paper elevation={3} sx={{ marginTop: "15px", padding: "10px" }}>
        <Box display="flex" gap={4} justifyContent="space-between">
          <Box width="100%">
            <Typography textAlign="center" variant="h4" color="success">
              INCOME
            </Typography>
            {incomeData?.map((income, index) => (
              <Box
                key={index}
                gap={1}
                columnGap={1}
                display="flex"
                justifyContent="space-between"
              >
                <Typography variant="h4" color="info">
                  {`${index + 1}. ${income.category}`}
                </Typography>
                {/* <Typography variant="h4" color="success">
                  {income.labRequestId}
                </Typography> */}
                <Typography variant="h4" color="success">
                  {income?.totalAmount
                    ? formatNumberWithCommas(Number(income.totalAmount))
                    : "0.00"}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box width="100%">
            <Typography textAlign="center" variant="h4" color="error">
              EXPENSE
            </Typography>
            {expenseData?.map((expense, index) => (
              <Box
                key={index}
                gap={1}
                columnGap={1}
                display="flex"
                justifyContent="space-between"
              >
                <Typography variant="h4" color="info">
                  {`${index + 1}. ${expense.expenseCategory}`}
                </Typography>
                {/* <Typography variant="h4" color="success">
                  {income.labRequestId}
                </Typography> */}
                <Typography variant="h4" color="error">
                  {expense?.amount
                    ? formatNumberWithCommas(Number(expense.amount))
                    : "0.00"}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Divider />
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" justifyContent="space-between" width="100%">
            <Typography
              variant="h3"
              color="success"
              textAlign="center"
              width="100%"
            >
              Total{" "}
            </Typography>
            <Typography
              variant="h3"
              color="success"
              textAlign="right"
              paddingRight="15px"
              width="100%"
            >
              {totalIncome
                ? formatNumberWithCommas(Number(totalIncome))
                : "0.00"}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Typography
              variant="h3"
              color="error"
              textAlign="center"
              width="100%"
            >
              Total{" "}
            </Typography>
            <Typography
              variant="h3"
              color="error"
              textAlign="right"
              width="100%"
            >
              {totalIncome
                ? formatNumberWithCommas(Number(totalExpense))
                : "0.00"}
            </Typography>
          </Box>
        </Box>
      </Paper>
      <PDFViewerDialog
        reportNo={`CASH_FLOW_${selectedDate}`}
        labRequestId={selectedDate.format("YYYY-MM-DD")}
        open={openCashFlowDialog}
        handleCloseReportPreview={handleCloseCashFlow}
        letterHead={""}
        reportType={"INCOMEEXPENSEMONTHWISE"}
        month={selectedMonth}
        year={selectedYear}
        monthName={selectedMonthName}
      />
    </Box>
  );
};

export default IncomeExpenseByMonth;
